import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// dayjs
import dayjs, { Dayjs } from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
// types
import RecurringTask from '../../interfaces/RecurringTask.interface';

interface RecurringTasksState {
  recurringTasks: RecurringTask[];
}

const initialState: RecurringTasksState = {
  recurringTasks: [],
};

function sortTasks(recurringTaskA: RecurringTask, recurringTaskB: RecurringTask): number {
  const dateA = dayjs(recurringTaskA.dueDate);
  const dateB = dayjs(recurringTaskB.dueDate);

  if (dateA.isBefore(dateB)) return -1;
  if (dateA.isAfter(dateB)) return 1;
  return 0; // keep original order if dates are equal
}

const recurringTasksSlice = createSlice({
  name: 'recurringTasks',
  initialState,
  reducers: {
    setRecurringTasks: (state, action: PayloadAction<RecurringTask[]>) => {
      let recurringTasksToBeAdded = action.payload;
      state.recurringTasks = recurringTasksToBeAdded.sort(sortTasks);
    },
    createRecurringTask: (state, action: PayloadAction<RecurringTask>) => {
      state.recurringTasks.push(action.payload);
      state.recurringTasks.sort(sortTasks);
    },
    updateRecurringTask: (state, action: PayloadAction<RecurringTask>) => {
      const index = state.recurringTasks.findIndex((recurringTask) => recurringTask.id === action.payload.id);
      if (index !== -1) {
        state.recurringTasks[index] = action.payload;
      }
      state.recurringTasks.sort(sortTasks);
    },
    deleteRecurringTask: (state, action: PayloadAction<number>) => {
      state.recurringTasks = state.recurringTasks.filter((recurringTask: RecurringTask) => recurringTask.id !== action.payload);
    },
    clearExcuse(state, action: PayloadAction<number>) {
      state.recurringTasks = state.recurringTasks
        .map((recurringTask) =>
          recurringTask.id === action.payload ? {
            ...recurringTask,
            excused: false,
            excuseExpiresAt: null,
          } : recurringTask
        );
    },
  },
});

export const {
  setRecurringTasks,
  createRecurringTask,
  updateRecurringTask,
  deleteRecurringTask,
  clearExcuse,
} = recurringTasksSlice.actions;

export default recurringTasksSlice.reducer;
